/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {EnvironmentalBenefitValueEditor} from "./EnvironmentalBenefitValueEditor";
import React from "react";

export function ModelUpliftEnvironmentalBenefitsTargetValueEditor(props) {
	const environmentalBenefitId = props?.Data?.SampleEvent?.environmentalBenefitId ?? -1;

	return <EnvironmentalBenefitValueEditor
		environmentalBenefitId={environmentalBenefitId}
		{...props}
	/>
}